import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Leaderboard from "./components/Leaderboard";
import TopNav from "./components/Topnav";
import { Divider } from "@mui/material";
import Glossary from "./components/Glossary";
import Footer from "./components/Footer";
import Donate from "./components/Donate";
import Articles from "./components/Articles";
import Article from "./components/Article";
import PageTracker from "./components/PageTracker";
import Trending from "./components/Trending";

import PlayerPage from "./components/PlayerPage";
import AflLeaderboard from "./components/AFL/AflLeaderboard";
import AflPlayerPage from "./components/AFL/AflPlayerPage";
import StuffBoard from "./components/StuffBoard";
import HitterPitchBoard from "./components/HitterPitchBoard";
import MlbContext from "./components/MlbContext";
import MlbComparison from "./components/MlbComparison";
import PSPlus from "./components/PSPlus";
import SplitsPage from "./components/SplitsPage";
import FramingBoard from "./components/FramingBoard";
import STLeaderboard from "./components/ST/STLeaderboard";
import STPlayerPage from "./components/ST/STPlayerPage";
import AuthCallback from "./components/AuthCallback";
import { AuthProvider, useAuth } from "./components/AuthContext";
import InAppBrowserModal from "./components/InAppBrowserModal";
import AdminPage from "./components/AdminPage";
//import PlayerPageTemp from "./components/PlayerPageTemp";

function PlusRoute({ element }: { element: React.ReactElement }) {
  const { user, loading } = useAuth();
  const { hostname } = window.location;
  const isLocal =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname);
  if (isLocal) return element;
  if (loading) return null;
  if (!user?.is_plus) return <Navigate to="/plus" replace />;
  return element;
}

function AppModals() {
  const { inAppBrowserBlocked, dismissInAppBrowserModal } = useAuth();
  return (
    <InAppBrowserModal
      open={inAppBrowserBlocked}
      onClose={dismissInAppBrowserModal}
    />
  );
}


export default function App() {
  const [searchText, setSearchText] = useState("");
  const [isDesktop, setDesktop] = useState(window.innerWidth > 1450);

  const prod = true

  //console.log(location)

  const setVP = () => {
    setDesktop(window.innerWidth > 1450);
  };

  useEffect(() => {
    window.addEventListener("resize", setVP, false);
  }, []);

  

  return (
    <div
      style={{ backgroundColor: "#E0FBFC", width: "100%", overflowY: "hidden" }}
    >
      <AuthProvider prod={prod}>
      <BrowserRouter>
      <AppModals />
      <PageTracker />
        {
          <div>
            <TopNav
              searchText={searchText}
              setSearchText={setSearchText}
              isDesktop={isDesktop}
              prod={prod}
            ></TopNav>
          </div>
        }
        <Routes>
          <Route path="/" element={<Navigate to="/leaders" />} />
          <Route
            path="/player/:id"
            element={<PlayerPage isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/leaders"
            element={<Leaderboard isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/donate"
            element={<Donate isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/articles"
            element={<Articles isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/trending"
            element={<Trending isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/article/:id"
            element={<Article isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/afl/leaders"
            element={<AflLeaderboard isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/afl/player/:id"
            element={<AflPlayerPage isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/st/leaders"
            element={<STLeaderboard isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/st/player/:id"
            element={<STPlayerPage isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/plus"
            element={<PSPlus isDesktop={isDesktop} prod={prod} />}
          />
          <Route
            path="/plus/stuff/"
            element={<PlusRoute element={<StuffBoard isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/plus/hitter-pitches/"
            element={<PlusRoute element={<HitterPitchBoard isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/plus/splits"
            element={<PlusRoute element={<SplitsPage isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/plus/splits/:id"
            element={<PlusRoute element={<SplitsPage isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/plus/framing/"
            element={<PlusRoute element={<FramingBoard isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/auth/callback"
            element={<AuthCallback />}
          />
          <Route
            path="/admin"
            element={<AdminPage />}
          />
          <Route
            path="/mlb-context/:id"
            element={<PlusRoute element={<MlbContext isDesktop={isDesktop} prod={prod} />} />}
          />
          <Route
            path="/mlb-comparison/:id"
            element={<PlusRoute element={<MlbComparison isDesktop={isDesktop} prod={prod} />} />}
          />
        </Routes>
        {
          <div>
            <Divider variant="fullWidth" />
            <Glossary isDesktop={isDesktop} />
            <Footer />
          </div>
        }
      </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

